<template>
  <div class="agreement">
    <box ref="box" :obj="obj" />
    <div class="button ta-c">
      <Button type="primary" :disabled="obj.toPdf === 0" @click="$refs['box'].getPdf()">下载协议</Button>
    </div>
  </div>
</template>

<script>
import box from "./cell/box"
export default {
  name: "Agreement",
  components: {
    box
  },
  data() {
    return {
      obj: {}
    }
  },
  created() {
    this.GetAgreement()
  },
  methods: {
    GetAgreement() {
      this.$store.dispatch('globe/GetAgreement').then(res => {
        this.obj = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.agreement{
  .button{
    margin: 40px 0 16px;
    text-align: center;
    .ivu-btn-primary{
      height: 44px;
      padding: 0 45px;
      font-size: 16px;
    }
  }
}
</style>